import { RESET_STATE } from 'store/global/actions';

import { LOAN_KEY_DATES_ACTION_TYPE } from '../actions';

const initialState = {};

const loanKeyDatesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_KEY_DATES_ACTION_TYPE.GET_LOAN_KEY_DATES:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanKeyDatesReducer;
